var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AutoTestRun_1;
import { Nothing } from 'purify-ts/Maybe';
import * as api from '@codegrade/api';
import { AutoTestStore } from '@/store/modules/autotest';
import { immutable, sortBy } from '@/utils';
let AutoTestRun = AutoTestRun_1 = class AutoTestRun {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, createdAt, autoTestId, isExtended) {
        this.id = id;
        this.createdAt = createdAt;
        this.autoTestId = autoTestId;
        this.isExtended = isExtended;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data, autoTestId) {
        return new AutoTestRun_1(data.id, data.createdAt, autoTestId, data instanceof api.ExtendedAutoTestRun);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get results() {
        // If we don't have an extended result we might still have some results
        // which we loaded individually, however getting the latest results will
        // not work.
        if (!this.isExtended) {
            return Nothing;
        }
        return AutoTestStore.getTest()(this.autoTestId).chain(AutoTestStore.getLatestResults());
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get sortedResults() {
        return this.results.map(results => sortBy(results, result => result.getSortKeys()));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    findResultBySubId(submissionId) {
        return AutoTestStore.getResultBySubmission()(this.id, submissionId);
    }
};
AutoTestRun = AutoTestRun_1 = __decorate([
    immutable
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], AutoTestRun);
export { AutoTestRun };
